import { PostHogConfig } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { AppRoot } from './App';
import './helpers/i18n';
import { saveInitialSource } from './services/Analytics';

saveInitialSource(document.location.search);

const posthogOptions: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-05-24',
};

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_API_KEY}
      options={posthogOptions}
    >
      <AppRoot />
    </PostHogProvider>
  </React.StrictMode>,
);
